/*
 * @Author: ben ben
 * @Date: 2026-01-21 15:52:15
 * @LastEditors: ben ben
 * @LastEditTime: 2026-01-26 15:58:24
 * @Description: file content
 */
/*
 * @Author: Sfcode Code
 * @Description: 反馈 SDK 工具函数 - 管理反馈平台 SDK 的初始化和调用
 */
import { notification } from 'antd';

/**
 * Feedback SDK 环境配置表
 * 通过 window.__SMART__.ENV 来匹配对应环境的配置
 */

const FEEDBACK_CONFIG = {
  sit: {
    env: 'sit',
    appId: '0c0635c9a4',
    appSecret: '5abc8bdc82a74d87967231f13f8ff5b7',
    scriptUrl:
      'https://pbs-feedback.sit.sf-express.com/assets/sdk/feedback/pc/latest/feedback-pc-sdk.umd.js',
  },
  prd: {
    env: 'prd',
    appId: '99f30371c7',
    appSecret: '2dc6470856a04de1a502c6d65397d738',
    scriptUrl:
      'https://pbs-feedback.sf-express.com/assets/sdk/feedback/pc/latest/feedback-pc-sdk.umd.js',
  },
};

/**
 * 根据当前环境获取 feedback 配置
 */
const getFeedbackConfig = () => {
  const env = window.__SMART__?.ENV === 'online' ? 'prd' : 'sit';
  return FEEDBACK_CONFIG[env];
};

let feedbackInstance = null;
let initPromise = null;
/**
 * 初始化反馈 SDK
 * @param {Object} userInfo - 用户信息 { userNo, userMobile }
 */
const initFeedbackSdk = (username) => {
  // 如果已经初始化过，直接返回 resolved Promise
  if (feedbackInstance) {
    return Promise.resolve(feedbackInstance);
  }

  initPromise = new Promise((resolve, reject) => {
    const feedbackConf = getFeedbackConfig();
    if (!feedbackConf?.scriptUrl) {
      console.warn(
        `[feedbackSdk] Feedback configuration not found for ENV=${window.__SMART__?.ENV}`,
      );
      return reject(new Error('Feedback configuration not found'));
    }
    const script = document.createElement('script');
    script.src = feedbackConf.scriptUrl;
    script.type = 'text/javascript';

    script.onload = () => {
      const { FeedbackPcSdk } = window;
      if (FeedbackPcSdk && !feedbackInstance) {
        try {
          feedbackInstance = new FeedbackPcSdk({
            env: feedbackConf.env,
            appId: feedbackConf.appId,
            appSecret: feedbackConf.appSecret,
            appCode: 'TS-SMART-CORE',
            userNo: username || '',
            userMobile: '',
            showBubble: false,
            placeholder: '请输入您宝贵的建议，我们会尽快处理。字数限制：200字以内。',
            rateTarget: {
              code: window.location.pathname,
              name: document.title,
            },
            // contactList: [],
            // rateFactors: [],

            onOpen() {
              if (feedbackInstance) {
                feedbackInstance.setSubTypeName('百川丰向标PC');
                feedbackInstance.setRateTarget({
                  code: window.location.pathname,
                  name: document.title,
                });
              }
            },
            onClose() {
              // 关闭弹框回调
            },
            onSubmitSuccess() {
              // eslint-disable-next-line no-undef
            },
            onAppendSuccess() {
              // eslint-disable-next-line no-undef
            },
          });
        } catch (error) {
          initPromise = null;
          reject(error);
        }
      }
      resolve(feedbackInstance);
      initPromise = null;
    };

    script.onerror = () => {
      const error = new Error(`Failed to load feedback SDK from ${feedbackConf.scriptUrl}`);
      reject(error);
      initPromise = null;
    };

    document.head.appendChild(script);
  });

  return initPromise;
};

/**
 * 销毁反馈 SDK
 */
const destroyFeedbackSdk = () => {
  if (feedbackInstance) {
    feedbackInstance.destroy();
    feedbackInstance = null;
    initPromise = null;
  }
};

/**
 * 打开反馈弹框
 * @param {Object} userInfo - 用户信息 { userNo, userMobile }
 */
const open = (username) => {
  console.log('open~~');
  if (feedbackInstance) {
    feedbackInstance.open();
  } else {
    initFeedbackSdk(username)
      .then(() => {
        if (feedbackInstance) {
          feedbackInstance.open();
        }
      })
      .catch((error) => {
        console.error('SDK 初始化失败:', error);
        notification.error({
          message: '意见反馈资源加载失败，请稍后再试',
          description: '',
        });
      });
  }
};

export default {
  open,
  destroy: destroyFeedbackSdk,
  getInstance: () => feedbackInstance,
};
